export const users = [
  {value: "cannelle", label: "Cannelle", color: "yellow"},
  {value: "isaac", label: "Isaac", color: "green"},
  {value: "matt", label: "Matt", color: "blue"},
  {value: "olivia", label: "Olivia", color: "pink"},
  {value: "robyn", label: "Robyn", color: "red"},
  {value: "roger", label: "Roger", color: "teal"},
];
